import * as React from 'react'
import { cva, type VariantProps } from 'class-variance-authority'
import { cn } from '@/utils/cn'

const badgeVariants = cva(
  'inline-flex items-center rounded-md border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2',
  {
    variants: {
      variant: {
        default:
          'border-transparent bg-primary text-primary-foreground shadow hover:bg-primary/80',
        secondary:
          'border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80',
        destructive:
          'border-transparent bg-destructive text-destructive-foreground shadow hover:bg-destructive/80',
        outline: 'text-foreground',
        // Michaels custom variants
        seasonal:
          'border-transparent bg-[#f6f2ff] text-[#8130f7] hover:bg-[#f6f2ff]/80',
        core: 'border-transparent bg-[#fffbec] text-[#cc6202] hover:bg-[#fffbec]/80',
        success:
          'border-transparent bg-green-100 text-green-700 hover:bg-green-100/80',
        warning:
          'border-transparent bg-yellow-100 text-yellow-700 hover:bg-yellow-100/80',
        info: 'border-transparent bg-blue-100 text-blue-600 hover:bg-blue-100/80',
        neutral:
          'border-transparent bg-muted text-muted-foreground hover:bg-muted/80',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  }
)

export interface BadgeProps
  extends
    React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return (
    <div className={cn(badgeVariants({ variant }), className)} {...props} />
  )
}

export { Badge, badgeVariants }
